import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CHAPTERS_GET',
  GET_SUCCESS: 'CHAPTERS_GET_SUCCESS',
  GET_FAILURE: 'CHAPTERS_GET_FAILURE',
  INVALIDATE_ITEM: 'CHAPTERS_INVALIDATE_ITEM',
  GET_ALL: 'CHAPTERS_GET_ALL',
  GET_ALL_SUCCESS: 'CHAPTERS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CHAPTERS_GET_ALL_FAILURE',
  POST: 'CHAPTERS_POST',
  POST_SUCCESS: 'CHAPTERS_POST_SUCCESS',
  POST_FAILURE: 'CHAPTERS_POST_FAILURE',
  PATCH: 'CHAPTERS_PATCH',
  PATCH_SUCCESS: 'CHAPTERS_PATCH_SUCCESS',
  PATCH_FAILURE: 'CHAPTERS_PATCH_FAILURE',
};

export const get = actions.get(chapterId => `${BASE_V2_URL}/chapters/${chapterId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  programID => `${BASE_V2_URL}/programs/${programID}/chapters/`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post(
  (id, value, { programID }) => `${BASE_V2_URL}/programs/${programID}/chapters/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const patch = actions.patch(chapterId => `${BASE_V2_URL}/chapters/${chapterId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
